import { customObjects } from './objects'
import { customPeoples } from './peoples'
import { customSymbols } from './symbols'

export const customEmojisSecurity = [].concat(customObjects, customPeoples, customSymbols)
